<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>

        <v-alert  :value="true"  v-if="error != null" type="error" v-html="error.message"></v-alert>

        <v-layout justify-center column>

          <v-form ref="form" v-model="valid" @submit="signUp">
            
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="firstName" :rules="firstNameRules" label="First name *" required ></v-text-field>
              </v-flex>

              <v-flex xs12 pb-0>
                <v-text-field outline v-model="lastName" :rules="lastNameRules" label="Last name *"  required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="username" :rules="usernameRules" type="email" label="Email address *" required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="usernameConfirm" :rules="confirmUsernameRules" type="email" label="Confirm email address *" required ></v-text-field>
              </v-flex>
            </v-layout>

             <v-layout row>
                <v-flex xs12 sm2>Date of Birth*</v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    :items="days"
                    label="DD"
                    v-model="dobDay"
                    required
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3 >
                  <v-select
                    :items="months"
                    label="MM"
                    v-model="dobMonth"
                    outline
                    required
                  ></v-select>
                  </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    :items="years"
                    label="YYYY"
                    v-model="dobYear"
                     :rules="dobValidation"
                    outline
                    required
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs3 pb-0>
                  <v-select
                    :hide-details="true"
                    label="Phone country"
                    :items="countries"
                    item-value="code"
                    v-model="phoneCountry"
                    outline
                    required
                  >
                    <template slot="selection" slot-scope="data">
                      <!-- HTML that describe how select should render selected items -->
                      +{{ data.item.phoneCode }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.name }} (+{{
                        data.item.phoneCode
                      }})
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs9>
                  <v-text-field
                    outline
                    v-model="phoneNumber"
                    :rules="phoneRules"
                    label="Mobile phone number"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>


            <v-layout row>
              <v-flex xs12 pb-0>
                <v-select
                  outline
                  :items="countries"
                  v-model="country"
                  item-text="name"
                  :rules="countryRules"
                  label="Country*"
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline ref="pass" v-model="pass" :rules="passRules" label="Password *" type="password" required ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field outline ref="passConfirm" v-model="passConfirm" :rules="passConfirmRules" label="Confirm password *"  type="password"  required></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <p class="password-notice">A valid password must contain one upper case letter, one lower case letter, a number and a special character (e.g. ^ $ * . ! @ # % &amp;) and also must be at least 8 characters in length.</p>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <p>Our <a :href="configStrings.clubPrivacyPolicyLink" target="_blank">EFL Website Privacy Policy</a> sets out details about how we use your information.</p>
                <v-switch
                  :label="`Please tick this box if you do want EFL to send you more emails or texts with offers and other promotional information relating to Fantasy EFL.`"
                  v-model="commsOptIn"
                  color="#001C3C"
                ></v-switch>
                <p>We know our fans are passionate about football, so we would like to send you information about events, surveys, competitions, offers, products, services and other exciting updates of ourselves and our official sponsors and partners.</p>
              </v-flex>
            </v-layout>

            

            <v-layout row>
              <v-flex xs12 pb-0>
              <p>If you would like to receive this information, please tick the applicable boxes below:</p>
              <p>Who would you like to receive information from?</p>
            </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs3 py-0></v-flex>
              <v-flex x9 py-0>
                <v-switch
                  v-model="clubOptIn"
                  color="#001C3C"
                >
                <template v-slot:label>My Club  
                <v-tooltip right>
                <template #activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    style="margin-left: 10px;"
                  >
                    info
                  </v-icon>
                </template>
                  <span>The club you select as your favourite when you first use Fantasy EFL</span>
                </v-tooltip>
                </template>
              </v-switch>

              <v-switch
                  :label="`EFL Group`"
                  v-model="eflOptIn"
                  color="#001C3C"
                >
                <template v-slot:label>EFL Group 
                <v-tooltip right>
                <template #activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    style="margin-left: 10px;"
                  >
                    info
                  </v-icon>
                </template>
                  <span> This includes EFL, EFL Digital
                    &amp; EFL Trust </span>
                </v-tooltip>
                </template>
              </v-switch>
              <v-switch
                  v-model="clubPartnerOptIn"
                  color="#001C3C"
                >
                <template v-slot:label>The official partners and sponsors of my club 
                <v-tooltip right>
                <template #activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    style="margin-left: 10px;"
                  >
                    info
                  </v-icon>
                </template>
                  <span>Details of the current official partners and sponsors for your club can be found on the club's official partners' page.</span>
                </v-tooltip>
                </template>
              </v-switch>
              <v-switch
                  v-model="eflPartnerOptIn"
                  color="#001C3C"
                >
                <template v-slot:label>The official partners and sponsors of EFL Group 
                <v-tooltip right>
                <template #activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    style="margin-left: 10px;"
                  >
                    info
                  </v-icon>
                </template>
                  <span>This includes EFL, EFL Digital
                    &amp; EFL Trust </span>
                </v-tooltip>
                </template>
              </v-switch>
              </v-flex>
            </v-layout>

            <p v-if="optedInToAny === true">How would you like to receive information?*</p>
            <p v-if="commsMethodMessage"  style="color: red;">{{this.commsMethodMessage}}</p>
            <v-layout row v-if="optedInToAny === true">

              <v-flex xs3 py-0></v-flex>
              <v-flex x6 py-0>
                <v-switch
                  id="commsMethodEmail"
                  :label="`Email`"
                  v-model="commsMethodEmail"
                  :rules="commsMethodValidation"
                  color="#001C3C"
                ></v-switch>
                <v-switch
                  id="commsMethodSMS"
                  :label="`SMS`"
                  v-model="commsMethodSMS"
                  :rules="commsMethodValidation"
                  color="#001C3C"
                ></v-switch> <v-icon icon="mdi-information">ff</v-icon>
                <v-switch
                  id="commsMethodPhone"
                  :label="`Phone`"
                  v-model="commsMethodPhone"
                  :rules="commsMethodValidation"
                  color="#001C3C"
                ></v-switch>
                <v-switch
                  id="commsMethodDM"
                  :label="`Online Direct Message`"
                  :rules="commsMethodValidation"
                  v-model="commsMethodDM"
                  color="#001C3C"
                ><v-icon icon="mdi-information"></v-icon></v-switch>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pt-0 pb-1>
                <v-switch
                  id="termsSwitch"
                  v-model="termsAgree"
                  :rules="termsAgreeRules"
                  color="#001C3C"
                ><template v-slot:label>I agree to the&nbsp;<a href="https://www.efl.com/terms-and-conditions/fantasy-efl/" target="_blank"> Fantasy EFL Terms &amp; Conditions</a>.*</template></v-switch>
              </v-flex>
            </v-layout>

    

            <v-layout row align-center mx-1 py-0>
              <router-link to="/" class="text-button">Already registered?</router-link>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid">Register</button>
            </v-layout>

          </v-form>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import { parsePhoneNumber } from 'awesome-phonenumber'
export default {
  name: 'Registration',
  data () {
    
    return {
      valid: true,
      firstNameRules: [
        v => !!v || 'First name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last name is required'
      ],
      countryRules: [
        v => !!v || 'Country is required'
      ],
      dobRules: [
        v => !! v || 'Date of birth is required',
        v => (this.dobYear+'-'+("0" + this.dobMonth).slice(-2)+'-'+("0" + this.dobYear).slice(-2)).toString() < new Date().toISOString().split('T')[0] || "Date can't be in the future"
      ],
      dobValidation: ['You must enter a date of birth'],
      commsMethodValidation: ['You must select at least one communication method'],
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        v => /.*[a-z].*/.test(v) || 'Password must contain at least one lower case letter',
        v => /.*[A-Z].*/.test(v) || 'Password must contain at least one upper case letter',
        v => /\d/.test(v) || 'Password must contain at least one number',
        v => /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) || 'Password must contain at least one special character (e.g. ^ $ * . ! @ # % &)',
        v => (this.passConfirm.length >=8 && v == this.passConfirm) || 'Password confirmation must match password'
      ],
      passConfirmRules: [
        v => (v == this.pass) || 'Password confirmation must match password'
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => (!v || /*v.length < 3 ||*/ /.+@.+/.test(v)) || 'Username must be a valid email',
        v => (!v || !v.includes(' ')) || 'An email address cannot contain any spaces'
      ],
      confirmUsernameRules: ['Email confirmation is required'],
      termsAgreeRules: [
        v => !!v || 'You must agree to continue'
      ],
      firstName: '',
      ssoid: '',
      lastName: '',
      username: '',
      usernameConfirm: '',
      phoneNumber: "",
      phoneCountry: "",
      phoneNormalised: "",
      pass: '',
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      country: '',
      commsOptIn: false,
      clubOptIn: false,
      eflOptIn: false,
      clubPartnerOptIn: false,
      eflPartnerOptIn: false,
      commsMethodEmail: false,
      commsMethodSMS: false,
      commsMethodPhone: false,
      commsMethodDM: false,
      optedInToAny: false,
      termsAgree: false,
      passConfirm: '',
      error: null,
      loading: false,
      communicationString: 'Email',
      communicationStringLong: 'emails',
      commsMethodMessage: null,
      countries: [],
      days: [],
      months: [],
      years: []
    }
  },
  created () {

    if(this.configValues.accountRegistrationPreferencesAreEmailOnly === false){
      this.communicationString = 'Communication'
      this.communicationStringLong = 'communications (via email, sms, phone or mail)'
    }

    this.populateDates ()
    fetch("/countries.json")
      .then(r => r.json())
      .then(
        json => {
          this.countries = json.countries;
        },
        response => {
          console.log("Error loading json:", response);
        }
      );
  },
  computed: {
    phoneRules() {
      const pn = parsePhoneNumber( this.phoneNumber , { regionCode: this.phoneCountry});
      //console.log('Phone number is', pn.valid)
      if (!this.phoneNumber) {
        // console.log('Phone number Doesn\'t exist but it is OK on reg')
        return ['You must enter a phone number'];
      } else {
        // console.log('Phone number exists')
        return [() => pn.valid|| "Please ensure you have selected your phone country and entered the number correctly"];
      }
    }
  },
  watch: {
    pass: function (val, oldVal) {
      this.$refs.form.validate()
    },
    passConfirm: function (val, oldVal) {
      this.$refs.form.validate()
    },
    username: function (val, oldVal) {
      this.validateUsernameRules()
    },
    usernameConfirm: function (val, oldVal) {
      this.validateUsernameRules()
    },
    dobDay: function (val, oldVal) {
      console.log('Day changed')
      this.validateDateOfBirth()
    },
    dobMonth: function (val, oldVal) {
      console.log('Month changed')
      this.validateDateOfBirth()
    },
    dobYear: function (val, oldVal) {
      console.log('Year changed')
      this.validateDateOfBirth()
    },
    clubOptIn: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    clubPartnerOptIn: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    eflOptIn: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    eflPartnerOptIn: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    commsMethodEmail: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    commsMethodPhone: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    commsMethodSMS: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    commsMethodDM: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    }


  },
  methods: {
    checkOptIns(){
      if (this.clubOptIn || this.clubPartnerOptIn || this.eflPartnerOptIn || this.eflOptIn ) {
        this.optedInToAny = true
       
      } else {
        this.optedInToAny = false
        this.commsMethodEmail = false
        this.commsMethodPhone = false
        this.commsMethodSMS = false
        this.commsMethodDM = false
      }
    },
    validateUsernameRules() {
      if(this.username === this.usernameConfirm){
          this.confirmUsernameRules = [true]

        }else{
          this.confirmUsernameRules = ['Email and confirmation do not match']
      }
    },
    validateCommsMethods() {

      if(
        this.optedInToAny === true &&  
        this.commsMethodEmail === false &&
        this.commsMethodPhone === false && 
        this.commsMethodSMS === false && 
        this.commsMethodDM === false  
        ) {
          this.commsMethodValidation = ['']
          this.commsMethodMessage = 'You must select at least one method of communication'
        } else{
          this.commsMethodValidation = [true]
          this.commsMethodMessage = null
        }
    },
    validateDateOfBirth() {
      // Validate date of birth fields only if all three are filled
      if (this.dobYear && this.dobMonth && this.dobDay) {

        // Optionally, you can also run the custom validation rule for date of birth
        const isValidDateOfBirth = this.isValidDate();

        var age = this.calculateAge(
            this.dobYear,
            this.dobMonth,
            this.dobDay
          ); // get age of the user based on the DoB fields


        if(isValidDateOfBirth){
          if(age < this.configValues.accountConsentAge){
            this.dobValidation = ['You must be at least '+ this.configValues.accountConsentAge +' years old.']
          }else{
            this.dobValidation = [true]
          }
        } else {
          this.dobValidation = ['Date of birth not valid']
        }
      }
      return false; // Date of birth is not fully entered yet
    },
    isValidDate() {
      const dateOfBirth = new Date(this.dobYear, this.dobMonth - 1, this.dobDay); // Month is 0-based
      const currentDate = new Date();
      return dateOfBirth <= currentDate;
    },
    pad (num, size) {
      var s = num+"";
      while (s.length < size) s = "0" + s;
      return s;
    },
    
    populateDates () {
      console.log('ADDING DATES')
      for(var d=1; d<32; d++){
        this.days.push(d)
      }
      for(var m=1; m<13; m++){
        this.months.push(m)
      }
      var thisYear = new Date().getFullYear()

      if(this.configValues.accountConsentRequired === true && this.configValues.accountConsentAge > 0){
        thisYear = thisYear - this.configValues.accountConsentAge
      }

      for(var y=thisYear+1; y > 1900 ; y--) {
        this.years.push(y)
      }
    },
    crmXCMPush(username){
      var crmXCMPushURL = process.env.VUE_APP_XCM_CRM_API+'/user/push/'+ username
      console.log('XCM push url', crmXCMPushURL)
      return axios({
        method: 'get',
        url: crmXCMPushURL
      })
    },
    complete(username){
      console.log('completing')
      var vm = this
      this.dataPush(username)
      .then(function (results) {
        console.log('redirecting after data push')
        //vm.$router.push("/post-registration-message");
        vm.$router.push("/confirm");
      });
    },
    signUp (e) {
        e.preventDefault()
        this.loading = true
        var email = this.username.toLowerCase()
        var password = this.pass
        var firstName = this.firstName
        var lastName = this.lastName
        var termsAgree = this.termsAgree.toString()
        
        var attributesList = {
            "given_name": firstName, 
            "family_name": lastName, 
            "custom:privacy_accepted": termsAgree
        }

        if (this.phoneNumber) {
          const pn = parsePhoneNumber( this.phoneNumber , { regionCode: this.phoneCountry});
          if(pn.valid === true){
            attributesList['phone_number'] = pn.number.e164
            // console.log('Saving phone', attributesList['phone_number'])
          }
        }

        var address = {
          country: this.country
        };

        attributesList["address"] = JSON.stringify(address);

        if (this.commsOptIn.toString() === 'true') {
          attributesList['custom:comms_opt_in'] = 'true'
        } else {
          attributesList['custom:comms_opt_in'] = 'false'
        }

        if (this.clubOptIn.toString() === 'true') {
          attributesList['custom:comms_club'] = 'true'
        } else {
          attributesList['custom:comms_club'] = 'false'
        }

        if (this.eflOptIn.toString() === 'true') {
          attributesList['custom:comms_org'] = 'true'
        } else {
          attributesList['custom:comms_org'] = 'false'
        }

        if (this.clubPartnerOptIn.toString() === 'true') {
          attributesList['custom:comms_club_partner'] = 'true'
        } else {
          attributesList['custom:comms_club_partner'] = 'false'
        }

        if (this.eflPartnerOptIn.toString() === 'true') {
          attributesList['custom:comms_org_partner'] = 'true'
        } else {
          attributesList['custom:comms_org_partner'] = 'false'
        }

        if (this.commsMethodEmail.toString() === 'true') {
          attributesList['custom:comms_method_email'] = 'true'
        } else {
          attributesList['custom:comms_method_email'] = 'false'
        }

        if (this.commsMethodSMS.toString() === 'true') {
          attributesList['custom:comms_method_sms'] = 'true'
        } else {
          attributesList['custom:comms_method_sms'] = 'false'
        }

        if (this.commsMethodPhone.toString() === 'true') {
          attributesList['custom:comms_method_phone'] = 'true'
        } else {
          attributesList['custom:comms_method_phone'] = 'false'
        }

        if (this.commsMethodDM.toString() === 'true') {
          attributesList['custom:comms_method_dm'] = 'true'
        } else {
          attributesList['custom:comms_method_dm'] = 'false'
        }




       

        if(this.dobDay && this.dobMonth && this.dobYear){
          attributesList['birthdate'] = this.dobYear + '-' + this.pad(this.dobMonth, 2) + '-' + this.pad(this.dobDay, 2)
        }
        var vm = this
        this.$signUp(email, password, attributesList).subscribe((data) => {
            console.log("sign up successful, data:", data.user)
            var username = data.user.username
            vm.complete(username)
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err.message)
            if(err.message === 'An account with the given email already exists.'){
              err.message = 'This is an existing ' +this.configStrings.productName + ' account - <a href="/forgot-password" class="text-button--login-error">Please click here to reset your password</a>'
            }
            vm.error = err
        });

    }
  }
}
</script>

<style lang="scss" scoped>
  .password-notice {
    margin: 0 0 20px;
    padding: 0 0 40px;
    color: $core-grey;
    font-size: 15px;
    line-height: 22px;
    border-bottom: 1px solid $core-light-grey;
  }

  .v-input--switch__track.theme--light.error--text {
    color: rgba(0,0,0,0.38) !important;
  }
  .v-input--selection-controls__ripple.error--text{
    color: $core-white !important;
  }
  .v-input--switch__thumb.theme--light.error--text{
    color:$core-lightest-grey !important;
  }

  .error {
    display: block;
  }
</style>